@if (status(); as status) {
    <span class="live" [class.reconnecting]="status === 'reconnecting'" role="status" [clTooltip]="copy().hint | translate">
        <span class="dot">
            @if (status === 'live') {
                <!-- re-created per landed value, replaying the one-shot ripple; template-literal track as in app-animated-value -->
                @for (update of [updates()]; track `${update}`) {
                    <span class="ripple"></span>
                }
            }
        </span>
        {{ copy().label | translate }}
    </span>
}
